import { useMemo } from 'react'
import { z } from 'zod'

import { requiredSelection } from '../../../../../app/_components/form/zodSchemas'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { allowedIconTextInputCharactersPattern } from '../../../../../containers/EmbroideryContainer/utils/unorganized'

export function useValidationSchema({ initialsMaxChars }: { initialsMaxChars: number }) {
  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  const validationSchema = useMemo(() => {
    return z.object({
      iconPlacement: requiredSelection(fixtures.validationErrorMessages.requiredIconPlacement),
      initials: z
        .string()
        .max(
          initialsMaxChars,
          fixtures.validationErrorMessages.textMaxCharsTemplate.replace(
            '{{max}}',
            initialsMaxChars.toString()
          )
        )
        // Initials are optional, so an empty value skips the character check rather than failing it.
        .refine(
          value => !value || allowedIconTextInputCharactersPattern.test(value),
          fixtures.validationErrorMessages.allowedInitialsTextCharacters
        )
        .optional(),
      initialsColor: requiredSelection(fixtures.validationErrorMessages.requiredSelection),
      iconImage: requiredSelection(fixtures.validationErrorMessages.requiredIcon),
    })
  }, [fixtures, initialsMaxChars])

  return validationSchema
}
